export function getFilterRoute (building, floor) {
  const layerOpacity = [
    'case',
    [
      'all',
      ['==', ['get', 'level'], floor.id],
      ['==', ['get', 'building'], building.id]
    ],
    0.8,
    0.32
  ]
  const arrowOpacity = [
    'case',
    [
      'all',
      ['==', ['get', 'level'], floor.id],
      ['==', ['get', 'building'], building.id]
    ],
    1,
    0.32
  ]

  return {
    layerOpacity,
    arrowOpacity
  }
}
